export default __webpack_public_path__ + "static/after-20552f5c81a0de6fb0b053f6f9cb0f51.png";